export const SET_IS_FETCHING = 'SET_IS_FETCHING';
export const GET_ORDER_DETAILS = 'GET_ORDER_DETAILS';
export const CLEAR_ORDER_DETAILS = 'CLEAR_ORDER_DETAILS';
